/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllowedGroundingFiles,
  ChatThreadModel,
  ChatTurn,
  ChatbotPerspectiveRole,
  ChatbotResponseDepthLevel,
  ChatbotResponseLength,
  ChatbotTone,
  ProblemDetails,
  SimpleChatRequestDto,
  SmartProblemDetails,
} from '../models/index';
import {
    AllowedGroundingFilesFromJSON,
    AllowedGroundingFilesToJSON,
    ChatThreadModelFromJSON,
    ChatThreadModelToJSON,
    ChatTurnFromJSON,
    ChatTurnToJSON,
    ChatbotPerspectiveRoleFromJSON,
    ChatbotPerspectiveRoleToJSON,
    ChatbotResponseDepthLevelFromJSON,
    ChatbotResponseDepthLevelToJSON,
    ChatbotResponseLengthFromJSON,
    ChatbotResponseLengthToJSON,
    ChatbotToneFromJSON,
    ChatbotToneToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SimpleChatRequestDtoFromJSON,
    SimpleChatRequestDtoToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface OnPostChatRequest {
    simpleChatRequestDto?: Omit<SimpleChatRequestDto, 'lastUserQuestion'>;
}

export interface OnPostChatWithFileRequest {
    history?: Array<ChatTurn>;
    threadId?: string;
    chatbotSettingsOverridesResponseDepthLevel?: ChatbotResponseDepthLevel;
    chatbotSettingsOverridesTone?: ChatbotTone;
    chatbotSettingsOverridesPerspectiveRole?: ChatbotPerspectiveRole;
    chatbotSettingsOverridesSafetyConservativeness?: number;
    chatbotSettingsOverridesResponseLength?: ChatbotResponseLength;
    responseLanguage?: string;
    enableWebSearch?: boolean;
    files?: Array<Blob>;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     */
    async chatGetAllowedGroundingFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllowedGroundingFiles>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Chat/allowed-grounding-files`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllowedGroundingFilesFromJSON(jsonValue));
    }

    /**
     */
    async chatGetAllowedGroundingFiles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllowedGroundingFiles> {
        const response = await this.chatGetAllowedGroundingFilesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async onPostChatRaw(requestParameters: OnPostChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatThreadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Chat`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SimpleChatRequestDtoToJSON(requestParameters['simpleChatRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatThreadModelFromJSON(jsonValue));
    }

    /**
     */
    async onPostChat(requestParameters: OnPostChatRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatThreadModel> {
        const response = await this.onPostChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async onPostChatWithFileRaw(requestParameters: OnPostChatWithFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatThreadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['history'] != null) {
            requestParameters['history'].forEach((element) => {
                formParams.append('History', element as any);
            })
        }

        if (requestParameters['threadId'] != null) {
            formParams.append('ThreadId', requestParameters['threadId'] as any);
        }

        if (requestParameters['chatbotSettingsOverridesResponseDepthLevel'] != null) {
            formParams.append('ChatbotSettingsOverrides.ResponseDepthLevel', requestParameters['chatbotSettingsOverridesResponseDepthLevel'] as any);
        }

        if (requestParameters['chatbotSettingsOverridesTone'] != null) {
            formParams.append('ChatbotSettingsOverrides.Tone', requestParameters['chatbotSettingsOverridesTone'] as any);
        }

        if (requestParameters['chatbotSettingsOverridesPerspectiveRole'] != null) {
            formParams.append('ChatbotSettingsOverrides.PerspectiveRole', requestParameters['chatbotSettingsOverridesPerspectiveRole'] as any);
        }

        if (requestParameters['chatbotSettingsOverridesSafetyConservativeness'] != null) {
            formParams.append('ChatbotSettingsOverrides.SafetyConservativeness', requestParameters['chatbotSettingsOverridesSafetyConservativeness'] as any);
        }

        if (requestParameters['chatbotSettingsOverridesResponseLength'] != null) {
            formParams.append('ChatbotSettingsOverrides.ResponseLength', requestParameters['chatbotSettingsOverridesResponseLength'] as any);
        }

        if (requestParameters['responseLanguage'] != null) {
            formParams.append('ResponseLanguage', requestParameters['responseLanguage'] as any);
        }

        if (requestParameters['enableWebSearch'] != null) {
            formParams.append('EnableWebSearch', requestParameters['enableWebSearch'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('Files', element as any);
            })
        }


        let urlPath = `/api/Chat/with-file`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatThreadModelFromJSON(jsonValue));
    }

    /**
     */
    async onPostChatWithFile(requestParameters: OnPostChatWithFileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatThreadModel> {
        const response = await this.onPostChatWithFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
